<script setup lang="ts">
import { getSalesInvoicePreviewAsPdf } from '@/api/salesInvoices';
import {inject,onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n()

const props = defineProps({
  invoice: {
    type: Object,
    required: true
  },
  email: {
    type: String,
    required: false
  },
})

const emailsAreSentToLoggedInUser = inject('emailsAreSentToLoggedInUser', false)
const userEmailAddress = inject('userEmailAddress', false)

const pdfUrl = ref<string | null>(null)

onMounted(() => {
  getSalesInvoicePreviewAsPdf(props.invoice.id)
    .then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      pdfUrl.value = url
    })
})
</script>

<template>
  <div>
    <p class="mb-4">
      <template v-if="invoice.should_send_email">
        {{ t('clickCreateSalesInvoiceToFinalizeAndSendInvoiceTo') }}
        <b>
          <template v-if="props.email">
            {{ props.email }}
          </template>
          <span v-else class="text-red">
            {{ t('noEmailAddressAvailable') }}
          </span>
        </b>
      </template>
      <template v-else>
        {{ t('clickCreateSalesInvoiceToFinalizeInvoiceWithoutSending') }}
      </template>
    </p>
    <iframe
      v-if="pdfUrl"
      :src="pdfUrl"
      class="preview-iframe"
    />
    <template v-else>
      PDF preview loading... 
    </template>
    <div v-if="pdfUrl" class="mt-2">
      <a :href="pdfUrl" :download="`${props.invoice.exact_online_id}.pdf`" target="_blank" rel="noopener">
        {{ t('downloadPdf') }}
      </a>
    </div>
    <template v-if="invoice.should_send_email">
      <v-alert v-if="emailsAreSentToLoggedInUser" type="info" density="compact" class="mt-5">
          {{ t('emailWillBeSentToLoggedInUser', {'emailAddress':userEmailAddress}) }}
      </v-alert>
    </template>
  </div>
</template>

<style scoped lang="scss">
.preview-iframe {
  width: 100%;
  height: calc(100vh - 320px);
  border: none;
}
</style>